import { REDIRECT } from '@/constants/common/urls';
import {IntegrationConnect, getSession, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode} from '@/imports-files/pages/clients/activities/integration-connected';
import {get_new_host} from '@/actions/pages/app/protected-routes';
import AesEncryption from "aes-encryption";


export async function authorizeUser(setPageName, queryClient, router)
{    
  const session = await getSession();
  const client_slug = session?.subdomain
  const slug  =  window.location.pathname.split('/')[3];
  let integrate_level = router.query.state
  let params = {} 
  let send_integrate_level = ''
  if(slug == 'slack'){
    send_integrate_level = integrate_level
    const hash = decrypt(integrate_level)
    integrate_level = JSON.parse(hash)?.integration_redirect_state || 'user'
  }
  else if(slug == 'linked-in'){
    send_integrate_level = integrate_level
    const hash = decrypt(integrate_level)
    integrate_level = JSON.parse(hash)?.integration_redirect_state || 'user'
  }
  else{
    send_integrate_level = integrate_level.replace('_quick_setup', '')
  }

  if(router.query.error || router.query.denied){
    redirectToIntegration(integrate_level, false, router, null)
    return null;
  }
  else if(slug == "twitter"){
    let code  =  new URLSearchParams(window.location.search).get('oauth_token');
    let verifier  =  new URLSearchParams(window.location.search).get('oauth_verifier');
    params = {code: code, integrate_level: send_integrate_level, verifier: verifier}
  }else{
    let code  =  new URLSearchParams(window.location.search).get('code');
    params = {code: code, integrate_level: send_integrate_level}
  }
  if(slug == "gmail"){ params.scope = router.query.scope }
  const result = await new IntegrationConnect().submitIntegrationCode(params, slug, client_slug)
  const status_code = result.status || result.response.status;

  switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        let response = result.data;
        if (response.success) {
          redirectToIntegration(integrate_level, true, router, null)
        }
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        let message = result.response.data.error
        redirectToIntegration(integrate_level, false, router, message)
        break;
      default:
        handleOtherResponseCode(status_code, router)
    }

}

function redirectToIntegration(state, success, router, message){
  if(state == "client"){
    let url = get_new_host() + REDIRECT.client.client_integrations
    router.replace({pathname: url, query: {success: success, message: message}})
  }
  else if(state == "client_quick_setup"){
    let url = get_new_host() + REDIRECT.client.quick_setup_page
    router.replace({pathname: url, query: {success: success, message: message, step: 'company_integrations'}})
  }
  else if(state == "user_quick_setup"){
    let url = get_new_host() + REDIRECT.client.quick_setup_page
    router.replace({pathname: url, query: {success: success, message: message, step: 'my_integrations'}})
  }
  else{
    let url = get_new_host() + REDIRECT.client.my_integrations
    router.replace({pathname: url, query: {success: success, message: message}})
  }
}

function decrypt(encrypted) {
  let secretPass = 'c52f6a7af1eab682bcc64b76600cda6354c6b8c8387d4e7bb38b296b85d87d6a'
  const aes = new AesEncryption()
  aes.setSecretKey(secretPass)
  const data = aes.decrypt(encrypted)
  return data
}

function encrypt(encrypted) {
  let secretPass = 'c52f6a7af1eab682bcc64b76600cda6354c6b8c8387d4e7bb38b296b85d87d6a'
  const aes = new AesEncryption()
  aes.setSecretKey(secretPass)
  const data = aes.decrypt(encrypted)
  return data;
}